<template>
  <div id="admin-authorize-layer">
    <el-button type="primary" class="add-authorize" size="small" @click="addAuthorizeHandle">添加授权+</el-button>
    <el-table :data="authData" size="small"
      style="width: 100%; width: 100%; box-shadow:0px 3px 8px 0px rgba(0, 0, 0, 0.08);">
      <el-table-column prop="name" label="姓名" width="100" align="center" />
      <el-table-column label="手机号" width="150" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="职位" width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.part }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="150" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == '0'">待审批</span>
          <span v-if="scope.row.status == '1'">审批通过</span>
          <span v-if="scope.row.status == '2'">拒绝或撤回</span>
          <!-- <span v-if="scope.row.status == '4'">撤回</span> -->
        </template>
      </el-table-column>
      <el-table-column label="授权印章" width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sealName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" v-show="scope.row.status == '0'" @click="showAuthorizeApplyHandle(scope.row.id)">查看申请
          </el-button>
          <el-button type="text" v-show="scope.row.status == '1'" @click="toBackHandle(scope.row)">收回印章</el-button>
          <el-button type="text" v-show="scope.row.status == '2' || scope.row.status == '4'"
            @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager-layer">
      <el-pagination :total="total" :current-page="page" style="margin-top: 8px; position: absolute; right: 0px;"
        layout="total, prev, pager, next, sizes" @size-change="sizeChange" @current-change="pageChange" />
    </div>

    <add-authorize @submitHandle="receiveSubmitData" ref="authorize" :isAdd="isAdd" :messageId="messageId">
    </add-authorize>
    <phone-verification :authorizeData="authorizeData" ref="verification"></phone-verification>
    <back-seal ref="back"></back-seal>
  </div>
</template>
<script>
import backSeal from './back-seal'
import addAuthorize from './add-authorize'
import phoneVerification from './phone-verification'
import initData from '@/mixins/initData'
import { deleteMessageApi } from '@/api/space/signatures'
import {
  mapState
} from 'vuex'
export default {
  mixins: [initData],
  components: {
    addAuthorize,
    phoneVerification,
    backSeal
  },
  data() {
    return {
      authorizeData: {},
      isAdd: true,
      messageId: ''
    }
  },
  computed: {
    authData() {
      var data = []
      if (this.data.length > 0) {
        this.data.forEach(item => {
          data.push({
            name: item.name,
            phone: item.phone.replace(/(\w{3})(\w+)(\w{4})/, function (x, y, z, p) {
              var i = "";
              while (i.length < z.length) { i += "*" }
              return y + i + p
            }),
            part: item.part,
            status: item.status,
            sealName: item.sealName,
            companyId: item.companyId,
            createTime: item.createTime,
            id: item.id,
            modifyTime: item.modifyTime,
            userId: item.userId,
            sealId: item.sealId
          })
        })

        return data
      }
    },
    ...mapState([
      'currentSpace'
    ])
  },
  created() {
    // this.getContractListHandle()
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit() {
      this.url = '/sealInfo/listSealInfoMessage'
      this.params = { pageIndex: this.page, pageSize: this.size, companyId: this.currentSpace.companyId || '' }
      return true
    },
    addAuthorizeHandle() {
      this.$refs.authorize.dialogVisible = true
      this.$refs.authorize.isAdd = true
      this.$refs.authorize.authorizeForm.userName = ''
      this.$refs.authorize.authorizeForm.sealName = ''
      this.$refs.authorize.authorizeForm.userId = ''
      this.$refs.authorize.authorizeForm.position = ''
      this.$refs.authorize.authorizeForm.phone = ''
      this.$refs.authorize.authorizeForm.sealId = ''
      this.$refs.authorize.authorizeForm.sealImg = ''
      this.$refs.authorize.init()
    },
    receiveSubmitData(data) {
      this.authorizeData = data
      this.$refs.verification.dialogVisible = true
    },
    showAuthorizeApplyHandle(messageId) {
      this.$refs.authorize.isAdd = false
      this.$refs.authorize.authorizeForm.messageId = messageId
      this.$refs.authorize.init()
      this.$refs.authorize.dialogVisible = true
    },
    toBackHandle(sealInfo) {
      this.$refs.back.messageId = sealInfo.id
      this.$refs.back.sealId = sealInfo.sealId
      this.$refs.back.userId = sealInfo.userId
      this.$refs.back.showSealInfoHandle()
      this.$refs.back.dialogVisible = true
    },
    deleteHandle(messageId) {
      this.$confirm('确定要删除吗', '温馨提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      }).then(() => {
        deleteMessageApi({
          messageId
        }).then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            this.$nextTick(() => {
              this.init()
            })
          }
        })
      }).catch(() => {
      });

    }
  }
}
</script>
<style>
#admin-authorize-layer .el-table th>.cell {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
}

#admin-authorize-layer .el-table .cell {
  font-size: 14px;
  color: #666666;
}
</style>
<style scoped>
#admin-authorize-layer {
  position: relative;
}

.add-authorize {
  margin: 20px 0 10px 22px;
}
</style>
